export default __webpack_public_path__ + "static/media/robotic-hand.65f650ac.svg";